import React, { FunctionComponent } from 'react';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import withStyles from 'react-jss';
import { Grid } from 'semantic-ui-react';
import { WithRouterProps, ClassProp } from 'helpers/types';
import ReportBase, { ReportParams } from 'scenes/Report/components/ReportBase';
import Query from 'scenes/Report/components/Query';

import GET_THIRD_PARTY_LAPSED_ACTIVITY from 'components/LapsedActivity/LapsedActivity.queries';
import { styles } from 'components/LapsedActivity/LapsedActivity.styles';
import LapsedActivity from 'components/LapsedActivity/components/LapsedActivity';

type Props = WithRouterProps & {
  height?: number;
  width?: number;
};

type LapsedActivity = {
  segmentLabel: number;
  redeemedCustomerPercent: number;
};

type Styles = ClassProp<typeof styles>;

type QueryResponse = {
  classes: Styles;
  lapsedUser: LapsedUser[];
};

type LapsedUser = {
  merchantId: string;
  lapsedUserSegment: string;
  numberOfCls: number;
};

const renderReport = (
  params: ReportParams,
  { height = 500, width = 500 }: Props,
) => ({ lapsedUser }: QueryResponse) => (
  <Grid>
    <ReportBase
      batchKey="safegraphLapsedUser"
      header="Lapsed Activity"
      params={params}
    >
      <LapsedActivity
        data={lapsedUser}
        height={height}
        width={width}
        isLarge
        outerRadius={240}
        innerRadius={120}
        isFullPage
      />
    </ReportBase>
  </Grid>
);

const SafegraphLapsedUser: FunctionComponent<Props> = (props) => {
  const params = queryString.parse(props.location.search) as ReportParams;

  return (
    <Query
      query={GET_THIRD_PARTY_LAPSED_ACTIVITY}
      queryKey="result"
      reportName="Lapsed Activity"
      batchKey="safegraphLapsedUser"
      variables={{ params }}
      render={renderReport(params, props)}
    />
  );
};

export default withRouter(withStyles(styles)(SafegraphLapsedUser));
